<script setup>

import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import axios from "axios";

const route = useRoute()
const dataForm = ref({
  name: '',
  phone: '',
  email: '',
  contents: '',
  client_path: '',
  client_ip: '',
  client_country: ''
})
const statusMessage = ref('');

function get_ip() {
  axios
      .get('https://api.ipify.org?format=json')
      .then(response => {
        dataForm.value.client_ip = response.data.ip
      })
      .catch(error => {
        console.log(error)
      })
}

function get_country() {
  axios
      .get('https://get.geojs.io/v1/ip/geo.json')
      .then(response => {
        dataForm.value.client_country = response.data.country
      })
      .catch(error => {
        console.log(error)
      })
}


function send_email() {
  dataForm.value.client_path = route.path
  if (dataForm.value.name === '') {
    statusMessage.value = 'The name cannot be empty!';
    return
  }
  if (dataForm.value.email === '') {
    statusMessage.value = 'The cannot be empty!';
    return
  }
  if (dataForm.value.phone === '') {
    statusMessage.value = 'The phone cannot be empty!';
    return
  }
  axios
      .post('/api/mail', dataForm.value)
      .then(response => {
        statusMessage.value = 'Email sent successfully!';
      })
      .catch(error => {
        statusMessage.value = 'Failed to send email.';
      });
}

onMounted(() => {
  get_ip()
  get_country()
})

</script>

<template>
<!-- kurigram_contact_area -->
  <div class="kurigram_contact_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="witr_section_title">
            <div class="witr_section_title_inner text-center">
              <h3>Our Contact</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row contact_top">
        <div class="col-lg-8 col-md-12 col-sm-12 contact2">
          <div class="apartment_area">
            <div class="witr_apartment_form">
              <form @submit.prevent="send_email">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <span><input v-model="dataForm.name" type="text" name="name" placeholder=" Name*"></span>
                  </div>
                  <div class="form-group col-md-6">
                    <div class="witr_form_field2">
                      <span><input v-model="dataForm.email" type="email" name="email" placeholder="Email*"></span>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <div class="witr_form_field2">
                      <span><input v-model="dataForm.phone" type="number" name="phone" placeholder="Phone*"></span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <span><textarea v-model="dataForm.contents" name="comment" placeholder="Comments/Message"></textarea></span>
                  <p v-if="statusMessage">{{ statusMessage }}</p>
                </div>
                <p>
                  <button type="submit" name="ok" class="btn btn-primary">Submit Now</button>
                </p>
                <div class="row">
                  <div class="col-lg-12 text-center">
                    <p class="form-messege"></p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12 contact_service">
          <div class="row">
            <div class="col-lg-12 col-md-6 col-sm-12">
              <div class="em-service2 sleft all_color_service">
                <div class="em_service_content ">
                  <div class="em_single_service_text width_height_link_0 ">
                    <div class="service_top_image"></div>
                    <div class="text_box witr_s_flex">
                      <div class="service_top_text all_icon_color">
                        <div class="em-service-icon">
                          <i class="aprova aprova-map"></i>
                        </div>
                      </div>
                      <div class="em-service-inner">
                        <div class="em-service-title">
                          <h3>Office Address </h3>
                        </div>
                        <div class="em-service-desc">
                          <p>Factory building in Shiquanzhongqiao Development Zone, Songgang, Shishan Town, Nanhai District, Foshan City;</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-6 col-sm-12">
              <div class="em-service2 sleft all_color_service">
                <div class="em_service_content ">
                  <div class="em_single_service_text width_height_link_0 ">
                    <div class="service_top_image"></div>
                    <div class="text_box witr_s_flex">
                      <div class="service_top_text all_icon_color">
                        <div class="em-service-icon">
                          <i class="flaticon flaticon-phone-call"></i>
                        </div>
                      </div>
                      <div class="em-service-inner">
                        <div class="em-service-title">
                          <h3>Office Address </h3>
                        </div>
                        <div class="em-service-desc">
                          <p>Gaotian Road,Mingcheng Town,Gaoming District,Foshan, Guangdong,China</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-6 col-sm-12">
              <div class="em-service2 sleft all_color_service">
                <div class="em_service_content ">
                  <div class="em_single_service_text width_height_link_0 ">
                    <div class="service_top_image"></div>
                    <div class="text_box witr_s_flex">
                      <div class="service_top_text all_icon_color">
                        <div class="em-service-icon">
                          <i class="flaticon flaticon-mail"></i>
                        </div>
                      </div>
                      <div class="em-service-inner">
                        <div class="em-service-title">
                          <h3>Message Us</h3>
                        </div>
                        <div class="em-service-desc">
                          <p>kary.huang@tpa-prefabhouse.com</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>